import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import NoticeTicker from "../components/NoticeTicker";
import Hero from "../components/Hero";
import NoticeBoard from "../components/NoticesBoard";
import About from "../components/About";
import Leadership from "../components/Leadership";
import FeaturedCourses from "../components/FeaturedCourses";
import Events from "../components/Events";
import EminentGuests from "../components/EminentGuests";
import Culture from "../components/Culture";
import Highlights from "../components/Highlights";
import Footer from "../components/Footer";

import { ChevronUp, ChevronDown } from "lucide-react";

export default function Home() {
  const [fontScale, setFontScale] = useState(1);
  const [showScrollTop, setShowScrollTop] = useState(false);
  const [showScrollBottom, setShowScrollBottom] = useState(true);

  const increaseFont = () => {
    setFontScale((prev) => Math.min(prev + 0.1, 1.3));
  };

  const decreaseFont = () => {
    setFontScale((prev) => Math.max(prev - 0.1, 0.8));
  };

  const resetFont = () => {
    setFontScale(1);
  };

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop =
        window.scrollY || document.documentElement.scrollTop;

      const windowHeight = window.innerHeight;
      const documentHeight =
        document.documentElement.scrollHeight;

      setShowScrollTop(scrollTop > 200);

      setShowScrollBottom(
        scrollTop + windowHeight < documentHeight - 50
      );
    };

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleScroll);

    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const scrollToBottom = () => {
    window.scrollTo({
      top: document.documentElement.scrollHeight,
      behavior: "smooth",
    });
  };

  return (
    <div className="relative w-full min-w-0 max-w-full overflow-x-clip">
      <div
        className="w-full min-w-0 max-w-full"
        style={{ zoom: fontScale }}
      >
        <Header />
        <Hero />
        <NoticeTicker />
        <NoticeBoard />
        <Leadership />
        <FeaturedCourses />
        <Events />
        <About />
        <Culture />
        <EminentGuests />
        <Highlights />
        <Footer />
      </div>

      {/* Scroll to Top Button */}
      {showScrollTop && (
        <button
          type="button"
          onClick={scrollToTop}
          aria-label="Scroll to top"
          title="Scroll to top"
          className="fixed right-5 bottom-20 z-[9999] flex h-11 w-11 items-center justify-center rounded-full border border-white/30 bg-[#8b1e2d] text-white shadow-lg transition-all duration-300 hover:-translate-y-1 hover:bg-[#6f1522] focus:outline-none focus:ring-2 focus:ring-[#8b1e2d] focus:ring-offset-2"
        >
          <ChevronUp size={25} strokeWidth={2.5} />
        </button>
      )}

      {/* Scroll to Bottom Button */}
      {showScrollBottom && (
        <button
          type="button"
          onClick={scrollToBottom}
          aria-label="Scroll to bottom"
          title="Scroll to bottom"
          className="fixed right-5 bottom-5 z-[9999] flex h-11 w-11 items-center justify-center rounded-full border border-white/30 bg-[#8b1e2d] text-white shadow-lg transition-all duration-300 hover:translate-y-1 hover:bg-[#6f1522] focus:outline-none focus:ring-2 focus:ring-[#8b1e2d] focus:ring-offset-2"
        >
          <ChevronDown size={25} strokeWidth={2.5} />
        </button>
      )}
    </div>
  );
}
